module.exports = __webpack_public_path__ + "static/legalia-logo-8fc1d7029d9233c49c37daef65f1295b.svg";